var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaneIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.40625,
    y: 0.652344,
    width: 13.5242,
    height: 13.5242,
    fill: "url(#pattern0_778_11711)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_778_11711",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_778_11711",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_778_11711",
    width: 96,
    height: 96,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAADpklEQVR4nO2dz48MQRTHJySEEOJKcGYTwoWEP4DEuhPLmdj9A0i4kVgiQkLY7NnEOm5CrL3s1vfbsx1zMIkfF+HAeddesIw0K9mDmenqqZrq2fp+kjpOqru/9d6rV/WmqlIRQgghhBBCiB5D8g3JZpt2UqL4FeBaOwEAfJqZmdksEfwJcKiDBWQi3JIAnmg2m2sAfO4gwhLJgxLBEwDud7ICkmm1Wl0rEfwIcCyHAJkrGpEAHpicnFwPYD6HCAskd0gED5B8nNMKnkoADyRJciqPAMoNPJGm6RYA33JagXIDHwB4ltcKlBv4EeC8hRtaMsYc8PEc0WKM2Q7gl4UVzCk3cAyAmoUVZCIMu36GqAFwyUYA5QaOSZJkr6UAWZtw/RxRA+BdARG0b+BQgBu2AmS5wfT09CZnDxEzAI4UsICs3Qz97Ktpj+BLAQGUG7gCwKMiVqDcwBHGmBMF3VDTGHPR1XNEvUfAv+v/RUTQvoELSD4pagXZbyurAZIf/veCSZKc7UHfZ7oQIIsHg5V+h+R4i5dbJLnHZ9/1en0rgO9dCPCx73MDAOfavGAjTdONnvuf6sYKSI5W+hkAuzuMsjHP/Q93KUD/5wat4sCKNuSr7zRNd9rsEazKfYNWcaBX8YDkqy6toL9zg3ZxoBfxgOSVbgXo69ygUxxY0R766J/kPgcC9HdukCMORNkALGbWT/J2rVYbCBYH1JiJ8ZPkvUajsS5IHFDjP6uYci6CRRxQ4x8R7lZcozhAm8G1lBUYuBZAcYBWAdrtX6sUB2g7Q3rtWgDFAVqJsCABGDRHmHctgKaiDOiCFIQZtk5J01CGm4YqANN29N9x9vGXBZD/Z27f/8L5UoT8P3O5nWzke1mMk/9nq4/+NZvtZFmv86WHsmzIJEmyP+oNmdBbkgCuRr0lGXpTHkA96k35kGUps7Ozu6IuSylBYdZI1IVZJShNfBl1aWLI4lxjzDaSP6Iuzg1cnj7E2MvTQ0JyIro5f1kwxmxYdnNxzfnLAoDBKOf8ZQHAWHRz/rLQ1B+1w0LyaEH3o6MKHAkwWsD16LAOV5B8X2D067gaF9RqtYECH18HNrkCwGXN+QMCYM7S9+vQPlcYHVsZFpIXolnnLyMkn1u4Hl1r4pJUh3eHxRhzWnP+gACo5nQ9usAh4PFkC1rn9wCA4zlHvy7x8QHJBzkE0DVWPmjqIrewJElyWHP+gJC83mmdX5d5egTAW63zCyGEEEIIISoR8RtOrGeGQ85RMAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaneIco);
export default __webpack_public_path__ + "static/media/PlaneIco.5010d8c1ff4b5ce883b32c27ab0e742f.svg";
export { ForwardRef as ReactComponent };